import * as React from "react";
import Select from "@mui/material/Select";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  statusArray,
  offlineConsultationArray,
  states,
} from "components/helpers";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import {
  Controller,
  useFormContext,
  useFieldArray,
  useWatch,
} from "react-hook-form";
import "./styles.css";
import htmlText from "../htmlText";
// import GrayBackgroundText from "../../../GrayBackgroundText";

export default function AcademicDetails() {
  const [expanded, setExpanded] = React.useState(0);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const {
    control,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "provider",
  });
  const watchedValue = useWatch("provider");

  const providerFields = watchedValue?.provider.length
    ? watchedValue?.provider
    : fields;

  return (
    <>
      {providerFields.map((item, index) => (
        <Accordion
          expanded={expanded === index}
          onChange={handleChange(index)}
          key={index}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>Provider #{index + 1}</Typography>
              {index >= 1 && <DeleteIcon onClick={() => remove(index)} />}
            </div>
          </AccordionSummary>
          <AccordionDetails style={{ display: "block" }}>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>NPI</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].npi`}
                  control={control}
                  defaultValue={item.npi}
                  rules={{
                    required: htmlText.thisFieldIsRequired,
                    pattern: {
                      value: /^\d{10}$/,
                      message: "NPI should be 10 digits",
                    },
                  }}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.npi)
                        }
                        onBlur={() => trigger(`provider[${index}].npi`)}
                      />
                      {errors?.provider &&
                        errors?.provider[index]?.npi?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.npi)
                            }
                          >
                            {errors?.provider[index]?.npi?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Provider Type</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider.${index}.provider_type`}
                  control={control}
                  defaultValue={item.provider_type}
                  render={({ field }) => (
                    <>
                      <Select
                        variant="standard"
                        native
                        style={{ width: "100%" }}
                        {...field}
                      >
                        <option value=""></option>
                        {["Individual", "Organization"].map((s) => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                      </Select>
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>First Name</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].first_name`}
                  defaultValue={item.first_name}
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.first_name)
                        }
                        onBlur={() => trigger(`provider[${index}].first_name`)}
                      />
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Last Name</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].last_name`}
                  control={control}
                  defaultValue={item.last_name}
                  render={({ field }) => (
                    <>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.last_name)
                        }
                        onBlur={() => trigger(`provider[${index}].last_name`)}
                      />
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Display Name</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].display_name`}
                  control={control}
                  defaultValue={item.display_name}
                  render={({ field }) => (
                    <>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.display_name)
                        }
                        onBlur={() =>
                          trigger(`provider[${index}].display_name`)
                        }
                      />
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Address Line 1</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].address1`}
                  control={control}
                  defaultValue={item.address1}
                  rules={{ required: htmlText.thisFieldIsRequired }}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.address1)
                        }
                        onBlur={() => trigger(`provider[${index}].address1`)}
                      />
                      {errors?.provider &&
                        errors?.provider[index]?.address1?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.address1)
                            }
                          >
                            {errors?.provider[index]?.address1?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Address Line 2</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].address2`}
                  control={control}
                  defaultValue={item.address2}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        required
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.address2)
                        }
                        onBlur={() => trigger(`provider[${index}].address2`)}
                      />
                      {errors?.provider &&
                        errors?.provider[index]?.address2?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.address2)
                            }
                          >
                            {errors?.provider[index]?.address2?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>City</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].city`}
                  control={control}
                  defaultValue={item.city}
                  rules={{ required: htmlText.thisFieldIsRequired }}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.city)
                        }
                        onBlur={() => trigger(`provider[${index}].city`)}
                      />
                      {errors?.provider &&
                        errors?.provider[index]?.city?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.city)
                            }
                          >
                            {errors?.provider[index]?.city?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>State</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].state_cd`}
                  control={control}
                  defaultValue={item.state_cd}
                  rules={{ required: htmlText.thisFieldIsRequired }}
                  render={({ field }) => (
                    <>
                      <Select
                        variant="standard"
                        native
                        style={{ width: "100%" }}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.state_cd)
                        }
                        {...field}
                      >
                        <option value=""></option>
                        {states.map((s) => (
                          <option key={s.value} value={s.value}>
                            {s.label}
                          </option>
                        ))}
                      </Select>
                      {errors?.provider &&
                        errors?.provider[index]?.state_cd?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.state_cd)
                            }
                          >
                            {errors?.provider[index]?.state_cd?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Zip Code</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].zip`}
                  control={control}
                  defaultValue={item.zip}
                  rules={{ required: htmlText.thisFieldIsRequired }}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.zip)
                        }
                        onBlur={() => trigger(`provider[${index}].zip`)}
                      />
                      {errors?.provider &&
                        errors?.provider[index]?.zip?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.zip)
                            }
                          >
                            {errors?.provider[index]?.zip?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Phone No</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].phone`}
                  control={control}
                  defaultValue={item.phone}
                  rules={{
                    required: false,
                    pattern: {
                      value: /^(\+\d{1,3}[- ]?)?\d{10}$/,
                      message: "Invalid contact number",
                    },
                  }}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.phone)
                        }
                        onBlur={() => trigger(`provider[${index}].phone`)}
                      />
                      {errors?.provider &&
                        errors?.provider[index]?.phone?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.phone)
                            }
                          >
                            {errors?.provider[index]?.phone?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Status</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider.${index}.status_cd`}
                  control={control}
                  defaultValue={item.status_cd}
                  render={({ field }) => (
                    <>
                      <Select
                        variant="standard"
                        native
                        style={{ width: "100%" }}
                        {...field}
                      >
                        <option value=""></option>
                        {statusArray.map((s) => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                      </Select>
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Offline Consultation</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider.${index}.offline_consultation`}
                  control={control}
                  defaultValue={item.offline_consultation}
                  render={({ field }) => (
                    <>
                      <Select
                        variant="standard"
                        native
                        style={{ width: "100%" }}
                        {...field}
                      >
                        <option value=""></option>
                        {offlineConsultationArray.map((s) => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                      </Select>
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Provider Image</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  defaultValue={item.provider_image}
                  name={`provider[${index}].provider_image`}
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.provider_image)
                        }
                        onBlur={() =>
                          trigger(`provider[${index}].provider_image`)
                        }
                      />
                      {errors?.provider &&
                        errors?.provider[index]?.provider_image?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.provider_image)
                            }
                          >
                            {errors?.provider[index]?.provider_image?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Tax Id</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].tax_id`}
                  defaultValue={item.tax_id}
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.tax_id)
                        }
                        onBlur={() => trigger(`provider[${index}].tax_id`)}
                      />
                      {errors?.provider &&
                        errors?.provider[index]?.tax_id?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.tax_id)
                            }
                          >
                            {errors?.provider[index]?.tax_id?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Tax Id Type</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`provider[${index}].tax_id_type`}
                  defaultValue={item.tax_id_type}
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.provider &&
                          Boolean(errors?.provider[index]?.tax_id_type)
                        }
                        onBlur={() => trigger(`provider[${index}].tax_id_type`)}
                      />
                      {errors?.provider &&
                        errors?.provider[index]?.tax_id_type?.message && (
                          <FormHelperText
                            error={
                              errors?.provider &&
                              Boolean(errors?.provider[index]?.tax_id_type)
                            }
                          >
                            {errors?.provider[index]?.tax_id_type?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      ))}
      <div className="udm-btn-cont">
        <button
          className="udm-save"
          type="button"
          onClick={() => {
            append({ applicationType: "", firstName: "" });
          }}
        >
          + Add New
        </button>
      </div>
    </>
  );
}
